module.exports = __webpack_public_path__ + "img/iconic.772ae4eb.png";